import "core-js/modules/es.array.push.js";
import ImagePreviewer from '@/components/ImagePreviewer.vue';
import VideoPreviewer from '@/components/VideoPreviewer.vue';
import { ossVideoSnapshot } from 'cfmoto-utils';
export default {
  props: {
    content: {
      type: String
    }
  },
  components: {
    VideoPreviewer,
    ImagePreviewer
  },
  data() {
    return {
      previewVideoOptions: {
        visible: false,
        src: '',
        type: ''
      },
      preivewImage: {
        images: [],
        visible: false
      }
    };
  },
  computed: {
    finalContent() {
      const viewportWidth = process?.env?.VUE_APP_VIEWPORT_WIDTH * 1;
      const viewportContent = (this.content || '').replace(/([\d]+px)/g, (reg, position) => {
        // console.log(reg, position, unit, viewportWidth);
        // position.replace('px','')*1/viewportWidth*100+'vw'
        return position.replace('px', '') * 1 / viewportWidth * 100 + 'vw';
      });
      return viewportContent.replace(/target="_blank"/g, '').replace(/<video(.*)src="([^\\"]+)"(.*)<\/video>/g, (reg, position, src) => {
        const poster = ossVideoSnapshot({
          src
        });
        return `<div class="section-video"><video poster="${poster}" src=${src}></video><em class="section-video-play"></em></div>`;
      });
    }
  },
  methods: {
    getElementByTag(e, tagName = 'A') {
      let target = e.target;
      while (target.tagName && target.tagName.toUpperCase() !== tagName && target.parentNode != null) {
        target = target.parentNode;
      }
      if (!target.tagName) return null;
      return target;
    },
    getElementByClass(e, className = 'A') {
      let target = e.target;
      while (target.getAttribute && !(target.getAttribute('class') || '').split(' ').some(classNameItem => classNameItem.trim() === className) && target.parentNode != null) {
        target = target.parentNode;
      }
      if (!target.tagName) return null;
      return target;
    },
    handleHref(e) {
      if (this.getElementByTag(e, 'A')) {
        const target = this.getElementByTag(e, 'A');
        const tagName = target.tagName.toUpperCase();
        const href = target.getAttribute('href');
        const patternHref = /^https:\/\/h5(-test)?\.cfmoto-oversea.com\/app/;
        if (tagName === 'A' && patternHref.test(href)) {
          e.preventDefault();
          e.stopPropagation();
          const path = href.replace(patternHref, '');
          this.$router.push({
            path
          });
          return;
        }
        return;
      }
      if (this.getElementByTag(e, 'IMG')) {
        const target = this.getElementByTag(e, 'IMG');
        const url = target.getAttribute('src');
        const href = target.getAttribute('data-href');
        if (href) {
          const patternHref = /^https:\/\/h5(-test)?\.cfmoto-oversea.com\/app/;
          if (patternHref.test(href)) {
            const path = href.replace(patternHref, '');
            this.$router.push({
              path
            });
            return;
          }
          window.location.href = href;
          return;
        }
        this.preivewImage.images = [url];
        this.preivewImage.visible = true;
        return;
      }
      if (this.getElementByClass(e, 'section-video')) {
        e.preventDefault();
        e.stopPropagation();
        const target = this.getElementByClass(e, 'section-video').querySelector('video');
        const url = target.getAttribute('src');
        const type = `video/${url.slice(url.lastIndexOf('.') + 1)}`;
        this.previewVideoOptions.type = type;
        this.previewVideoOptions.src = url;
        this.previewVideoOptions.visible = true;
      }
    }
  },
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {}
};